var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "btn btn-purple ml-2",
        attrs: { disabled: !_vm.hasSelected },
        on: { click: _vm.add },
      },
      [_vm._v("ADD\n    ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }